import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "properties_tab",
  class: "relative my-6"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationPopup = _resolveComponent("NotificationPopup")!
  const _component_PropertyBlock = _resolveComponent("PropertyBlock")!
  const _component_OverlaySpinner = _resolveComponent("OverlaySpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.widget.edited)
      ? (_openBlock(), _createBlock(_component_NotificationPopup, {
          key: 0,
          status: "warning",
          title: "Changes Unpublished",
          text: "To view your updates on the widget, please save and publish them.",
          class: "mb-6"
        }))
      : _createCommentVNode("", true),
    (_ctx.widget_info?.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.principalSources, (w_source, index) => {
            return (_openBlock(), _createBlock(_component_PropertyBlock, {
              key: `${index}${w_source.principal_id}`,
              principal_id: w_source.principal_id,
              sources: w_source.sources,
              principals: _ctx.widget_info.principals,
              widgets: _ctx.widget,
              onUpdateWidget: _ctx.updateWidget
            }, null, 8, ["principal_id", "sources", "principals", "widgets", "onUpdateWidget"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_OverlaySpinner, {
          key: 2,
          hasOverlay: false,
          class: "h-[50vh]"
        }))
  ]))
}